import React, { useState } from "react";
import FormButtonStyle4 from "../../UIElements/FormButton"; // <-- update this path
import CustomCheckbox from "../customCheckBox/customCheckBox";
import callApi from "../../../../utility/apiCaller";
import { useSelector } from "react-redux";
import Header from "../Header/header";

const TermsAndConditions = ({
  setCurrentStep,
  selectedOffer,
  // leadId = "68b16603596d4397307eccb3",
}) => {
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [agreeGPay, setAgreeGPay] = useState(false);
  const user = useSelector((state) => state.app.user);
  const aaSlice = useSelector((state) => state?.aa);
  let leadId = aaSlice?.internalLeadId;

  // handleNext
  const handleNext = async () => {
    if (!agreeTerms || !agreeGPay) return; // ensure both are true

    try {
      const payload = {
        lead: {
          kyc_consent: true,
          website_kyc_consent: true,
          website_kyc_consent_datetime: new Date().toISOString(),
          kyc_consent_datetime: new Date().toISOString(),
        },
      };

      const res = await callApi(
        `v1/lead/${leadId}/update-lead-new`,
        "post",
        payload,
        "core",
        user?.token
        ||  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
      );

      await callApi(
        `v1/lead/${leadId}/update-lead-new`,
        "post",
        {
          lead: {
            is_terms_completed: true,
            steps_completed: 8,
          },
        },
        "core",
        user?.token ||
                   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
      );

      //console.log("API Response:", res); // check if success really comes

      setCurrentStep((prev) => prev + 1); // move to next step
    } catch (err) {
      console.error("Error updating lead:", err);
    }
  };

  return (
    <div className="w-full h-[100dvh] max-w-[400px] font-atkinson bg-white flex flex-col">
      {/* Header */}
      <Header />

      {/* Progress Bar */}
      {/* <div className="w-full h-[2px] bg-gray-200">
                <div className="h-full bg-green-500 w-[30%]"></div>
            </div> */}

      {/* Content */}
      <div className="flex flex-col px-6 mt-1 flex-grow">
        <h2 className="font-atkinson text-[22px] font-bold text-black mb-4">
          Terms & Conditions
        </h2>

        {/* Checkbox 1 */}
        <label className="flex items-start gap-2 mb-3">
          <CustomCheckbox setchecked={setAgreeTerms} checked={agreeTerms} />
          <p className="font-atkinson text-[10px] leading-[12px] text-[#B3B3B3]">
            I agree that the loan applied for from DMI Finance Private Limited
            will be governed by the {" "}
            <a
             href="https://www.dmifinance.in/wp-content/uploads/2025/10/loan-application-undertaking-English.pdf"
             target="_blank"
             className="text-blue-400 text-[11px] cursor-pointer">
              Loan application Undertaking
            </a>
          </p>
        </label>

        {/* Checkbox 2 */}
        <label className="flex items-start gap-2">
          <CustomCheckbox checked={agreeGPay} setchecked={setAgreeGPay} />
          <p className="font-atkinson text-[10px] leading-[12px] text-[#B3B3B3]">
            I declare that my gross household income is greater than Rs. 25,000
            per month. To process my application, I give my explicit consent to
            DMI Finance to obtain my credit report(s) from credit bureaus, to
            fetch required information for KYC from approved agencies including
            UIDAI, to reach out to me with personalized offers on products &
            services through SMS, WhatsApp, RCS, Email and telephonic calls/bots
            and this consent will override any registration for
            DND and/ or NDNC.
          </p>
        </label>
      </div>

      {/* Button */}
      <div className="px-6 xs:px-0 py-6">
        <FormButtonStyle4
          text="Next"
          onClick={handleNext}
          disabled={!agreeTerms || !agreeGPay}
          className="w-full font-atkinson"
        />
      </div>
    </div>
  );
};

export default TermsAndConditions;
